import StorageList from './StorageList'
// import StorageCreate from './StorageCreate'
import StorageEdit from './StorageEdit'

export default {
  list: StorageList,
  // create: StorageCreate,
  edit: StorageEdit,
}
